// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"f6aa7eb4","326":"147b2694","460":"aca08c58","478":"e28e4956","488":"8c5125db","504":"b7c03359","530":"a82e4a4f","692":"add8626f","807":"9ed2fc56","868":"0e4e9606","918":"9672ecaa","937":"9c5889b7"}[chunkId] + ".chunk.js";
};